module.exports = __webpack_public_path__ + "static/media/image-link.b76c7cd7.svg";